import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "search"]

  filter(event) {
    const query = event.target.value.toLowerCase()

    this.optionTargets.forEach((option) => {
      const match = option.textContent
        .toLowerCase()
        .includes(query.trim().toLowerCase())

      option.classList.toggle("tw:hidden", !match)
    })

    this.dispatch("filtered")
  }

  focus() {
    this.searchTarget.focus()
  }
}
